import React, { useState, useMemo } from 'react';
import { Country } from 'country-state-city';

const CountrySelect = ({ onCountryChange, initialCountry = 'Select Target Country' }) => {
  const [selectedCountryName, setSelectedCountryName] = useState(initialCountry);
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');


  const allCountries = useMemo(() => Country.getAllCountries(), []);

  // Filter countries based on search term
  const filteredCountries = useMemo(() => {
    if (!searchTerm) {
      return allCountries;
    }
    const lowerCaseSearch = searchTerm.toLowerCase();
    return allCountries.filter(country => 
      country.name.toLowerCase().includes(lowerCaseSearch)
    );
  }, [searchTerm, allCountries]);

  const handleSelect = (country) => {
    setSelectedCountryName(country.name);
    setIsOpen(false);
    setSearchTerm('');
    onCountryChange(country); 
  };
  
  // Custom Class for Styling
  const customClass = "country-dropdown-fixed";

  return (
    <div className={customClass}>
      <div 
        className={`${customClass}-selected`} 
        onClick={() => setIsOpen(!isOpen)}
      >
        <p>{selectedCountryName}</p>
        <span className={`${customClass}-arrow ${isOpen ? 'up' : 'down'}`}>▼</span>
      </div>

      {isOpen && (
        <div className={`${customClass}-list`}>
          <input
            type="text"
            placeholder="Search country..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className={`${customClass}-search-input`}
          />
          
          <div className={`${customClass}-options`}>
            {filteredCountries.length > 0 ? (
              filteredCountries.map((country) => (
                <p 
                  key={country.isoCode} 
                  className={`${customClass}-item`}
                  onClick={() => handleSelect(country)}
                >
                  {country.name}
                </p>
              ))
            ) : (
              <p className={`${customClass}-no-results`}>No countries found.</p>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default CountrySelect;